import { supabase, TABLES, COLUMN_MAPS } from '../supabase';
import { ChatMessage } from '../../types';

// ============================================
// Messages Service
// ============================================

export const messagesApi = {
  /**
   * Get messages for a project
   */
  async getByProject(projectId: string): Promise<ChatMessage[]> {
    const { data, error } = await supabase
      .from(TABLES.MESSAGES)
      .select('*')
      .eq('project_id', projectId)
      .order('timestamp', { ascending: true });
    
    if (error) throw error;
    return (data || []).map(COLUMN_MAPS.message.fromDb);
  },

  /**
   * Get recent messages for a project
   */
  async getRecent(projectId: string, limit = 50): Promise<ChatMessage[]> {
    const { data, error } = await supabase
      .from(TABLES.MESSAGES)
      .select('*')
      .eq('project_id', projectId)
      .order('timestamp', { ascending: false })
      .limit(limit);
    
    if (error) throw error;
    
    // Reverse to get chronological order
    return (data || []).reverse().map(COLUMN_MAPS.message.fromDb);
  },

  /**
   * Create a message
   */
  async create(message: ChatMessage): Promise<void> {
    const dbData = COLUMN_MAPS.message.toDb(message);
    
    const { error } = await supabase
      .from(TABLES.MESSAGES)
      .insert(dbData);
    
    if (error) {
      console.error('Message insertion failed:', error);
      throw error;
    }
  },

  /**
   * Delete a message
   */
  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from(TABLES.MESSAGES)
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  /**
   * Delete all messages for a project
   */
  async deleteByProject(projectId: string): Promise<void> {
    const { error } = await supabase
      .from(TABLES.MESSAGES)
      .delete()
      .eq('project_id', projectId);
    
    if (error) throw error;
  },
};

export default messagesApi;
